var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-4", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { sm: "9", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Projects",
                  items: _vm.projectNames,
                  multiple: "",
                  dense: "",
                  chips: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function (ref) {
                      var item = ref.item
                      var index = ref.index
                      return [
                        index < 4
                          ? _c(
                              "v-chip",
                              {
                                attrs: {
                                  small: "",
                                  color: "primary",
                                  outlined: "",
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(item))])]
                            )
                          : _vm._e(),
                        index === 4
                          ? _c(
                              "span",
                              { staticClass: "grey--text text-caption" },
                              [
                                _vm._v(
                                  " (+" +
                                    _vm._s(_vm.selectedProjects.length - 4) +
                                    " others) "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedProjects,
                  callback: function ($$v) {
                    _vm.selectedProjects = $$v
                  },
                  expression: "selectedProjects",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-2", attrs: { sm: "3", cols: "12" } },
            [
              _c("v-select", {
                attrs: { label: "Year", items: _vm.yearRange, multiple: "" },
                model: {
                  value: _vm.selectedYears,
                  callback: function ($$v) {
                    _vm.selectedYears = $$v
                  },
                  expression: "selectedYears",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.projectStorages.length
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" Storages ")]),
              _c(
                "v-expansion-panels",
                {
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.storagesPanels,
                    callback: function ($$v) {
                      _vm.storagesPanels = $$v
                    },
                    expression: "storagesPanels",
                  },
                },
                _vm._l(_vm.projectStorages, function (storage, i) {
                  return _c(
                    "v-expansion-panel",
                    { key: i },
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(" " + _vm._s(storage.resourceName) + " "),
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-expansion-panels",
                            {
                              staticClass: "px-4",
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.storagesDataPanels[i],
                                callback: function ($$v) {
                                  _vm.$set(_vm.storagesDataPanels, i, $$v)
                                },
                                expression: "storagesDataPanels[i]",
                              },
                            },
                            _vm._l(_vm.storagesDataKey, function (key, index) {
                              return _c(
                                "v-expansion-panel",
                                { key: key, staticClass: "px-4" },
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.camelToTitleCase(key)) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    { staticClass: "pa-4" },
                                    [
                                      _c("Plotly", {
                                        attrs: {
                                          layout: _vm.storagesLayouts[index],
                                          toImageButtonOptions:
                                            _vm.chartDownloadName(
                                              _vm.caseName,
                                              "SSE",
                                              _vm.storagesLayouts[index].title
                                            ),
                                          data: _vm.getTotalChartData(
                                            storage.resourceId,
                                            "storages",
                                            key
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.projectGenerators.length
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" Generators ")]),
              _c(
                "v-expansion-panels",
                {
                  attrs: { multiple: "" },
                  model: {
                    value: _vm.generatorsPanels,
                    callback: function ($$v) {
                      _vm.generatorsPanels = $$v
                    },
                    expression: "generatorsPanels",
                  },
                },
                _vm._l(_vm.projectGenerators, function (generator, i) {
                  return _c(
                    "v-expansion-panel",
                    { key: i },
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(" " + _vm._s(generator.resourceName) + " "),
                      ]),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c(
                            "v-expansion-panels",
                            {
                              staticClass: "px-4",
                              attrs: { multiple: "" },
                              model: {
                                value: _vm.generatorsDataPanels[i],
                                callback: function ($$v) {
                                  _vm.$set(_vm.generatorsDataPanels, i, $$v)
                                },
                                expression: "generatorsDataPanels[i]",
                              },
                            },
                            _vm._l(_vm.generatorsDataKey, function (key) {
                              return _c(
                                "v-expansion-panel",
                                { key: key, staticClass: "px-4" },
                                [
                                  _c("v-expansion-panel-header", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.camelToTitleCase(key)) +
                                        " "
                                    ),
                                  ]),
                                  _c(
                                    "v-expansion-panel-content",
                                    { staticClass: "pa-4" },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { sm: "3" },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.projectStorages,
                                              multiple: "",
                                              "return-object": "",
                                              label: "Storage",
                                              "item-text": "resourceName",
                                            },
                                            model: {
                                              value: _vm.selectedStorageToComp,
                                              callback: function ($$v) {
                                                _vm.selectedStorageToComp = $$v
                                              },
                                              expression:
                                                "selectedStorageToComp",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._l(
                                        _vm.selectedYears,
                                        function (year) {
                                          return _c(
                                            "v-col",
                                            { key: year },
                                            [
                                              _c("Plotly", {
                                                attrs: {
                                                  layout: _vm.layoutCreation(
                                                    year,
                                                    "P&L [$]"
                                                  ),
                                                  toImageButtonOptions:
                                                    _vm.chartDownloadName(
                                                      _vm.caseName,
                                                      "SSE",
                                                      _vm.layoutCreation(
                                                        year,
                                                        "P&L [$]"
                                                      ).title
                                                    ),
                                                  data: _vm.getResourceCompChartData(
                                                    year,
                                                    _vm.selectedStorageToComp,
                                                    generator,
                                                    key
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }